import React, { useEffect } from 'react';
import { Box, Text, useToast, Button } from '@chakra-ui/react';
import { findNotificationDocIdByPushId, getNotificationById } from '../utils/notificationUtils';
import { useNavigate } from 'react-router-dom';

const AppPushToast: React.FC = () => {
  const toast = useToast();
  const navigate = useNavigate();

  const showToast = (detail: any) => {
    console.log('📱 [AppPushToast] showToast detail:', detail);
    const title = detail?.title || 'Notification';
    const body = detail?.body || '';
    const pushId = detail?.pushId || detail?.data?.notificationId || detail?.data?.pushId || detail?.data?.id || detail?.id;
    const target = pushId ? `/notifications/${pushId}` : '/notifications';
    const toastId = `app-push-${Date.now()}-${Math.random().toString(36).slice(2,8)}`;

    toast({
      id: toastId,
      render: () => (
        <Box
          position="relative"
          color="white"
          p={3}
          bg="blue.600"
          borderRadius="md"
          boxShadow="lg"
            onClick={() => {
              (async () => {
                try {
                  let dest = target;
                  if (pushId) {
                    try {
                      const docId = await findNotificationDocIdByPushId(pushId, 4, 400);
                      if (docId) {
                        try {
                          const notif = await getNotificationById(docId);
                          const t = notif?.type;
                          const soId = notif?.data?.salesOrderId;
                          if ((t === 'sales_order_approver' || t === 'sales_order_created' || t === 'sales_order_updated') && soId) {
                            dest = `/sales-order/${soId}`;
                          } else {
                            dest = `/notifications/${docId}`;
                          }
                        } catch (err) {
                          dest = `/notifications/${docId}`;
                        }
                      } else dest = `/notifications?openPushId=${encodeURIComponent(pushId)}`;
                    } catch (err) {
                      dest = `/notifications?openPushId=${encodeURIComponent(pushId)}`;
                    }
                  }

                  try { navigate(dest); } catch (navErr) { console.warn('📱 [AppPushToast] navigate failed', navErr); }
                  window.dispatchEvent(new CustomEvent('notification-navigate', { detail: { type: 'NOTIFICATION_CLICKED', url: dest, notificationId: pushId } }));
                  try { window.postMessage({ type: 'NOTIFICATION_CLICKED', url: dest, notificationId: pushId }, '*'); } catch (e) {}

                  // Force navigation fallback for PWAs where React Router navigate may not take effect
                  setTimeout(() => {
                    try {
                      if (window.location.pathname !== dest.split('?')[0]) {
                        console.log('📱 [AppPushToast] navigate fallback to', dest);
                        window.location.assign(dest);
                      }
                    } catch (err) {
                      /* ignore */
                    }
                  }, 120);
                } catch (e) {
                  console.error('📱 [AppPushToast] Error dispatching notification-navigate:', e);
                } finally {
                  toast.close(toastId);
                }
              })();
            }}
        >
          <button
            aria-label="Close"
            onClick={(e) => { e.stopPropagation(); toast.close(toastId); }}
            style={{
              position: 'absolute',
              top: 8,
              right: 8,
              background: 'transparent',
              border: 'none',
              color: 'white',
              fontSize: 20,
              cursor: 'pointer',
              lineHeight: 1,
            }}
          >
            ×
          </button>
          <Text fontWeight="bold" fontSize="md" mb={1}>
            {title}
          </Text>
          <Text fontSize="sm">
            {body}
          </Text>
          <Box mt={2} textAlign="right">
            <Button
              size="sm"
              variant="ghost"
              style={{ color: 'white', background: 'rgba(255,255,255,0.06)' }}
              onClick={(e) => {
                  e.stopPropagation();
                  (async () => {
                    try {
                      let dest = target;
                      if (pushId) {
                        try {
                          const docId = await findNotificationDocIdByPushId(pushId, 4, 400);
                          if (docId) {
                            try {
                              const notif = await getNotificationById(docId);
                              const t = notif?.type;
                              const soId = notif?.data?.salesOrderId;
                              if ((t === 'sales_order_approver' || t === 'sales_order_created' || t === 'sales_order_updated') && soId) {
                                dest = `/sales-order/${soId}`;
                              } else {
                                dest = `/notifications/${docId}`;
                              }
                            } catch (err) {
                              dest = `/notifications/${docId}`;
                            }
                          } else dest = `/notifications?openPushId=${encodeURIComponent(pushId)}`;
                        } catch (err) {
                          dest = `/notifications?openPushId=${encodeURIComponent(pushId)}`;
                        }
                      }

                      try { navigate(dest); } catch (navErr) { console.warn('📱 [AppPushToast] navigate failed', navErr); }
                      window.dispatchEvent(new CustomEvent('notification-navigate', { detail: { type: 'NOTIFICATION_CLICKED', url: dest, notificationId: pushId } }));
                      try { window.postMessage({ type: 'NOTIFICATION_CLICKED', url: dest, notificationId: pushId }, '*'); } catch (err) {}

                      setTimeout(() => {
                        try {
                          if (window.location.pathname !== dest.split('?')[0]) {
                            console.log('📱 [AppPushToast] View fallback to', dest);
                            window.location.assign(dest);
                          }
                        } catch (err) {}
                      }, 120);
                    } catch (err) {
                      console.error('📱 [AppPushToast] View button dispatch error:', err);
                    } finally {
                      toast.close(toastId);
                    }
                  })();
                }}
            >
              View
            </Button>
          </Box>
        </Box>
      ),
      duration: 10000,
      isClosable: true,
      position: 'top',
    });
  };

  useEffect(() => {
    const handler = (ev: Event) => {
      try {
        const detail = (ev as CustomEvent).detail || {};
        showToast(detail);
      } catch (e) {
        console.error('📱 [AppPushToast] Handler error:', e);
      }
    };

    window.addEventListener('app-push', handler as EventListener);
    return () => window.removeEventListener('app-push', handler as EventListener);
  }, [toast]);

  useEffect(() => {
    (window as any).__showAppPushToast = (detail: any) => {
      try {
        showToast(detail || {});
      } catch (e) {
        console.error('📱 [AppPushToast] __showAppPushToast error:', e);
      }
    };
    return () => { delete (window as any).__showAppPushToast; };
  }, [toast]);

  return null;
};

export default AppPushToast;
